/**
 * Global Redux State Objects
 * Contains global loading state
 */

import { 
  SET_AUTH_ERROR,
  CLEAR_AUTH_ERROR,
  UPDATE_SMART_LOADER
} from "../../actions/app/constants";

const defaultState = {
  isLoading: [],
  smartLoader: {
    loading: false,
    steps: []
  },
  isAuthError: false
};

// Named globalReducer, not global: a top-level `const global` shadows the
// Node global object, which is a redeclaration error inside Jest's VM
// context. That made every suite importing the store fail to even parse.
export const globalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_AUTH_ERROR:
      return {
        ...state,
        isAuthError: true,
        isLoading: []
      };
    case CLEAR_AUTH_ERROR:
      return {
        ...state,
        isAuthError: false
      };
    case UPDATE_SMART_LOADER:
      return {
        ...state,
        smartLoader: action.loader
      };
    default:
      return state;
  }
};
